export const FETCH_TESTOBX_PER_TECHNICIAN_REQUEST = 'FETCH_TESTOBX_PER-TECHNICIAN_REQUEST';
export const FETCH_TESTOBX_PER_TECHNICIAN_SUCCESS = 'FETCH_TESTOBX_PER_TECHNICIAN_SUCCESS';
export const FETCH_TESTOBX_PER_TECHNICIAN_FAILURE = "FETCH_TESTOBX_PER_TECHNICIAN_FAILURE";